var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('px-view-header',{attrs:{"title":"Grupos","breadcrumbs":_vm.breadcrumbs}}),_c('px-grupo-header',{on:{"refresh":_vm.refresh,"change":_vm.onChangeFilter}}),_c('px-grupo-list',{attrs:{"grupos":_vm.grupos,"loading":_vm.loading,"options-list":_vm.optionsList},on:{"update":_vm.refresh,"change":_vm.onChangeOptions}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }